import type { Npc, RoomDef } from '../defs.ts'
import { look } from '../town/kit.ts'

/** Lotus Teahouse: rosewood tables, a round moon window onto the canal, scrolls and lanterns. */
export const room: RoomDef = {
  id: 'lotus',
  name: 'Lotus Teahouse',
  blurb: 'Longjing tea and a moon window onto the canal.',
  w: 11, d: 9, outdoor: false, ground: 'planks', accent: '#e0564f',
  wall: { color: '#f4ede0', trim: '#8a3b2e' },
  zones: [],
  spawn: [5, 4],
  props: [
    { kind: 'rug', x: 1.5, y: 1.5, w: 8, d: 6, color: '#c0392b' },
    { kind: 'table', x: 3, y: 3, color: '#6b3a2a' }, { kind: 'stool', x: 2, y: 3, face: 1 }, { kind: 'stool', x: 4, y: 3, face: -1 },
    { kind: 'table', x: 7, y: 3, color: '#6b3a2a' }, { kind: 'stool', x: 6, y: 3, face: 1 }, { kind: 'stool', x: 8, y: 3, face: -1 },
    { kind: 'table', x: 3, y: 6, color: '#6b3a2a' }, { kind: 'stool', x: 2, y: 6, face: 1 }, { kind: 'stool', x: 4, y: 6, face: -1 },
    { kind: 'table', x: 7, y: 6, color: '#6b3a2a' }, { kind: 'stool', x: 6, y: 6, face: 1 }, { kind: 'stool', x: 8, y: 6, face: -1 },
    { kind: 'screen', x: 8, y: 0, color: '#f2e2c0' },
    { kind: 'shelf', x: 0, y: 7, rot: 1 },
    { kind: 'plant', x: 10, y: 8 }, { kind: 'lamp', x: 10, y: 1 },
  ],
  walls: [
    { kind: 'moon', wall: 'back', at: 3, len: 2.4 },
    { kind: 'scroll', wall: 'back', at: 6.2, len: 1, text: '山水' },
    { kind: 'scroll', wall: 'left', at: 1.6, len: 1, text: '福' },
    { kind: 'door', wall: 'left', at: 4, len: 1 },
    { kind: 'window', wall: 'left', at: 5.6, len: 1.4 },
  ],
  portals: [{ x: 0, y: 4, to: 'town', out: [1, 4], label: 'Outside' }],
  critters: [{ kind: 'cat', loop: [[9.5, 7.6], [5.2, 8.3], [1.5, 8.2], [1.5, 5.2]], speed: 0.4 }],
  places: [], spots: [], cap: 24, softCap: 18,
}

export const npcs: Npc[] = [
  {
    id: 'npc-long', name: 'Master Long', role: 'Tea master', look: look('masterlong', 5, 0, 3, 'none'), speed: 0.9,
    stops: [
      { x: 5, y: 1, wait: 18, say: -1 },
      { x: 5, y: 5, wait: 10, emote: 'happy', say: -1 },
      { x: 9, y: 4, wait: 14, emote: 'thinking' },
    ],
    lines: ['Longjing, from the hills by the lake.', 'Pour, wait, listen to the leaves open.', 'The moon window frames whatever you bring to it.', 'One more cup? There is always one more cup.'],
  },
]
